import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { CheckCircle } from '@mui/icons-material';
import BookingForm from '../components/BookingForm';
import { getColleges } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { navigateAndScroll } from '../utils/navigation';
import { useLocation } from 'react-router-dom';
import SEO from '../components/common/SEO';

function BookingPage() {
  const [colleges, setColleges] = useState([]);
  const [booked, setBooked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    async function loadColleges() {
      try {
        const data = await getColleges();
        if (!cancelled && data && data.colleges) {
          setColleges(data.colleges);
        }
      } catch {
        // colleges will remain empty
      }
    }
    loadColleges();
    return () => { cancelled = true; };
  }, []);

  if (booked) {
    return (
      <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
        <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
          You're All Set!
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
          Your cybersecurity assessment has been booked and payment received.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          We're matching you with a qualified intern now. You'll receive a confirmation
          email once an intern accepts your booking. If you have any questions,
          use our contact form to reach us.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button variant="contained" size="large"
            onClick={() => navigateAndScroll(navigate, '/', location.pathname)}
            sx={{ background: 'linear-gradient(135deg, #2563eb, #7c3aed)', fontWeight: 600, px: 4 }}>
            Back to Home
          </Button>
          <Button variant="outlined" size="large"
            onClick={() => navigateAndScroll(navigate, '/faq', location.pathname)}
            sx={{ fontWeight: 600, px: 4 }}>
            View FAQ
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <SEO title="Book Assessment" description="Book your cybersecurity assessment with Cyber Wise Corp. Choose your college, schedule, and pay securely." />
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
          Book Your Assessment
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
          Secure your home or business with an expert-reviewed cybersecurity assessment.
        </Typography>
      </Box>
      <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }} elevation={2}>
        <BookingForm colleges={colleges} onSuccess={() => setBooked(true)} />
      </Paper>
    </Container>
  );
}

export default BookingPage;
